import { oc } from '@orpc/contract';
import { policyVersionSchema } from '../schemas/policies.schemas.js';
/**
 * The policy every valuation runs on. Readable by any signed-in member — the estimator needs it in the
 * browser to preview a price as the salesperson types (plan §2.5).
 */
export const getPublishedPolicyContract = oc
    .route({
    method: 'GET',
    path: '/policies/published',
    tags: ['Policies'],
    summary: 'The published equation policy of the caller’s tenant',
})
    .output(policyVersionSchema);
//# sourceMappingURL=get-published-policy.contract.js.map